import { booleanAttribute, Directive, Input } from '@angular/core';

/**
 * Directive to handle the intersection observer. Check the IntersectionObserverDirective for more information
 */
@Directive({
  standalone: true,
  selector: '[intersectionObserve]'
})
export class IntersectionObserverDirective {
  @Input() intersectionAnimation?: 'none' | 'scale-up' | 'slide-up' | 'slide-left' | 'slide-right';

  @Input() intersectionAnimationMobile?: 'none' | 'scale-up' | 'slide-up' | 'slide-left' | 'slide-right';

  /**
   * The animation should be played backwards (when scrolling up)
   */
  @Input({ transform: booleanAttribute }) intersectionAnimationBackwards = false;

  /**
   * Value used to filter the elements that should be observed. Remeber that this value is readed as lowercased.
   */
  @Input() intersectionRef?: string;

  @Input() intersectionAnimationOnce: 'true' | 'false' = 'false';
}
